import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import LordIcon from './LordIcon';
import NumberCounter from './NumberCounter';
import './about.css';

const Info = () => {
  const [projectCount, setProjectCount] = useState('Error loading');
  const startYear = 2024;
  const [activeIcon, setActiveIcon] = useState(1); // Start with first icon active

  // Fungsi untuk menghitung tahun pengalaman
  const calculateExperience = () => {
    const currentYear = new Date().getFullYear();
    const years = currentYear - startYear;
    return `${years}+ Years`;
  };

  // Fungsi untuk mendapatkan warna ikon berdasarkan tema
  const getIconColor = () => {
    const isDarkMode = document.documentElement.classList.contains('dark-mode');
    return isDarkMode ? '#dbdbdb' : '#505050';
  };

  // Menambahkan state untuk warna ikon
  const [iconColor, setIconColor] = useState(getIconColor());

  // Effect untuk memperbarui warna ikon saat tema berubah
  useEffect(() => {
    const updateIconColor = () => {
      setIconColor(getIconColor());
    };

    // Observer untuk mendeteksi perubahan class pada documentElement
    const observer = new MutationObserver(updateIconColor);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Ambil data dari tabel "projects"
    const fetchProjects = async () => {
      const { data, error } = await supabase
        .from('projects')
        .select('id');  // Kita hanya perlu mengambil 'id' untuk menghitung jumlahnya

      if (error) {
        console.error('Error fetching projects:', error);
        setProjectCount('Error loading');
        return;
      }

      // Set jumlah proyek
      setProjectCount(data.length);
    };

    fetchProjects();
  }, []);

  useEffect(() => {
    const totalDuration = 12000; // 12 seconds total cycle
    let timeouts = []; // Store all timeouts for cleanup

    const startSequence = () => {
      // Pre-calculate all timings
      const timings = [
        { icon: 1, delay: 0 },
        { icon: 2, delay: 4000 },
        { icon: 3, delay: 8000 },
      ];

      // Schedule all animations
      timings.forEach(({ icon, delay }) => {
        const timeout = setTimeout(() => {
          setActiveIcon(icon);
        }, delay);
        timeouts.push(timeout);
      });

      // Schedule sequence restart
      const restartTimeout = setTimeout(startSequence, totalDuration - 100);
      timeouts.push(restartTimeout);
    };

    startSequence();

    return () => timeouts.forEach(clearTimeout);
  }, []);

  return (
    <motion.div 
      className='about__info grid'
      initial={{ opacity: 1 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="about__box">
        <div className="icon-container">
          <LordIcon
            src="https://cdn.lordicon.com/ppyvfomi.json"
            trigger={activeIcon === 1 ? "in" : "none"}
            colors={`primary:${iconColor}`}
            size="24px"
          />
        </div>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">{calculateExperience()}</span>
      </div>

      <div className="about__box">
        <div className="icon-container">
          <LordIcon
            src="https://cdn.lordicon.com/oqdmuxru.json"
            trigger={activeIcon === 2 ? "in" : "none"}
            colors={`primary:${iconColor}`}
            size="24px"
          />
        </div>
        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">
          <NumberCounter end={projectCount} /> Projects
        </span>
      </div>

      <div className="about__box">
        <div className="icon-container">
          <LordIcon
            src="https://cdn.lordicon.com/fdxqrdfe.json"
            trigger={activeIcon === 3 ? "in" : "none"}
            colors={`primary:${iconColor}`}
            size="24px"
          />
        </div>
        <h3 className="about__title">Support</h3>
        <span className="about__subtitle">Online 24/7</span>
      </div>
    </motion.div>
  );
};

export default Info;
